import { signal } from "../net/signal";

/**
 * چیزهایی که نمای حکم «هنوز نشان نداده» — جدا از وضعیتِ سرور.
 *
 * سرور حق دارد حکمِ ربات را یک ثانیه بعدِ شروع بفرستد؛ ولی صحنه باید اول
 * آس‌کشی را تمام کند، بعد پنج برگ را پخش کند، بعد حکم را اعلام کند. تابلوی
 * امتیاز جدا از میز رندر می‌شود (در App)، پس این‌که «حکم اعلام شده یا نه» باید
 * جایی بیرونِ هر دو بنشیند تا مدالِ حکم پیش از اعلام روشن نشود.
 */
export const trumpShown = signal(false);
